module.exports = __webpack_public_path__ + "static/media/18ECA23.953e017e.jpg";